<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jDyDHA/tc-custom/9780061859649.jpg?1718044595439" alt="This image is the cover for the book Birth House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Birth House
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this breathtaking debut novel, Ami McKay has created an unforgettable portrait of the struggles that women have faced to control their own bodies and to keep the best parts of tradition alive in the world of modern medicine.</b></p><p><i>The Birth House</i> is the story of Dora Rare—the first daughter in five generations of Rares. As apprentice to the outspoken Acadian midwife Miss Babineau, Dora learns to assist the women of an isolated Nova Scotian village through infertility, difficult labors, breech births, unwanted pregnancies, and even unfulfilling sex lives. During the turbulent World War I era, uncertainty and upheaval accompany the arrival of a brash new medical doctor and his promises of progress and fast, painless childbirth. Dora soon finds herself fighting to protect the rights of women as well as the wisdom that has been put into her care.</p><p>A tale of tradition and science, matriarchy and paternalism, past and future, <i>The Birth House</i> is "a dazzling first novel." (<i>Library Journal</i>), and a story more timely than ever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ami McKay
      </h2>
      
      <p class="authorDescription body article"><P>Ami McKay is the author of the number&#8211;one Canadian bestseller <I>The Birth House</I>, winner of three Canadian Booksellers Association Libris Awards, and a nominee for the International IMPAC Dublin Literary Award, and <I>The Virgin Cure</I>. Originally from Indiana, she now lives with her husband and two sons in Nova Scotia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4da824fe